
// exemplo de componente de tela de confirmacao
// uso de propriedades e de eventos em componentes

//https://www.youtube.com/watch?v=TXsMmIV112k
//https://github.com/amitavroy/inferno/tree/master/resources/assets/js/components

// exemplo de uso:
//https://github.com/amitavroy/inferno/tree/master/resources/assets/js/components/user-activation




<script type="text/babel">
export default {
  props: ['url', 'key', 'message', 'btnClass', 'btnText'],
  created() {
    this.modalState = true

    //this.$nextTick(function () {
    //  jQuery(this.$el).find('.modal').modal({
    //    backdrop: true,
    //    keyboard: true
    //  })
    //})
  },
  data() {
    return {
      dataToSend: null,
      modalState: false
    }
  },
  methods: {
    handleCloseButton() {
      this.modalState = false
      this.$emit('close')
    },
    handleActionButton() {
      this.modalState = true
    },
    handleConfirmButton() {
      this.$emit('onConfirm')
      this.handleCloseButton()
    }
  }
}
</script>

<template>
  <transition>
    <div class="modal nb-modal-scrollable modal-mask" style="display: block">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content nb-modal-scrollable-container ">
          <div class="modal-header">
            <h4 class="def-title" id="exampleModalLabel">{{ message }}</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
              v-on:click="handleCloseButton()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="height: 555px; overflow-y: auto">
            <img style="width:100%;height: 100%;" :src="url" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm" data-dismiss="modal" v-on:click="handleConfirmButton()">Fechar e
              não exibir novamente</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/msg-banner-modal.vue